export default __webpack_public_path__ + "static/media/logo-hurst.c44969d6.svg";